"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Slider = exports.SliderDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var react_slider_1 = __importDefault(require("react-slider"));
exports.SliderDefaultProps = {
  min: 0,
  max: 10,
  size: 24,
  showValue: false
};
// -------- Styles -------->
var SliderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n    ", "\n\n    ", "\n  "], ["\n    width: 100%;\n    ", "\n\n    ", "\n  "])), function (props) {
    return (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), props.size);
  }, function (props) {
    return props.disabled && (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      opacity: 0.3;\n    "], ["\n      opacity: 0.3;\n    "])));
  })
});
var TrackStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    top: 0;\n    bottom: 0;\n    cursor: pointer;\n    ", ";\n    background-position: center left;\n    \n    ", "\n  "], ["\n    top: 0;\n    bottom: 0;\n    cursor: pointer;\n    ", ";\n    background-position: center left;\n    \n    ", "\n  "])), theme_1.theme.H_DOT_BG(), function (props) {
    return props.disabled && (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      cursor: default;\n    "], ["\n      cursor: default;\n    "])));
  })
});
var ThumbStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    outline: none;\n    cursor: grab;\n    position: absolute;\n    font-weight: 600;\n    background: ", ";\n    color: ", ";\n    display: flex;\n    box-sizing: border-box;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    border: 2px solid ", ";\n    transition: border-color 0.3s;\n    font-size: ", ";\n    ", "\n\n    &.active {\n      outline: none;\n    }\n\n    ", "\n    \n    \n  "], ["\n    outline: none;\n    cursor: grab;\n    position: absolute;\n    font-weight: 600;\n    background: ", ";\n    color: ", ";\n    display: flex;\n    box-sizing: border-box;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    border: 2px solid ", ";\n    transition: border-color 0.3s;\n    font-size: ", ";\n    ", "\n\n    &.active {\n      outline: none;\n    }\n\n    ", "\n    \n    \n  "])), theme_1.theme.COLOR('light'), theme_1.theme.COLOR('dark'), theme_1.theme.COLOR('dark'), theme_1.theme.FONT_SIZE(12), function (props) {
    return (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n      line-height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n      line-height: ", "px;\n    "])), props.size, props.size, props.size - 2);
  }, function (props) {
    return props.disabled && (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      cursor: default; \n    "], ["\n      cursor: default; \n    "])));
  })
});
// -------- Components -------->
var My = {
  Slider: (0, styled_components_1.default)(react_slider_1.default)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), SliderStyles),
  Track: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), TrackStyles),
  Thumb: styled_components_1.default.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), ThumbStyles)
};
var Slider = function (props) {
  var className = props.className,
    min = props.min,
    max = props.max,
    size = props.size,
    defaultValue = props.defaultValue,
    showValue = props.showValue,
    disabled = props.disabled;
  // compose components with height 
  var Track = function (props, state) {
    return react_1.default.createElement(My.Track, __assign({
      disabled: disabled
    }, props, {
      size: size
    }));
  };
  var Thumb = function (props, state) {
    return react_1.default.createElement(My.Thumb, __assign({
      disabled: disabled
    }, props, {
      size: size
    }), showValue && state.valueNow);
  };
  return react_1.default.createElement(My.Slider, __assign({}, props, {
    size: size,
    defaultValue: defaultValue || min,
    renderTrack: Track,
    renderThumb: Thumb
  }));
};
exports.Slider = Slider;
exports.Slider.defaultProps = exports.SliderDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11;